
// import React, { useEffect, useState, useContext } from "react";
// import { Container, Row, Col } from "react-bootstrap";
// import {
//   GetPostMethodData,
//   DecryptAESdata,
// } from "../../../../provider/ServiceProvider";
// // import "./MarketOutlook.css";
// // import animation from "../../images/jm-animation.gif";
// import animation from "../../../../images/jm-animation.gif";
// import { Modal } from "react-bootstrap";
// import { AiFillCloseCircle } from "react-icons/ai";
// // import URLstateContext from "../../provider/CommonContext";
// import URLstateContext from "../../../../provider/CommonContext";

// function Calendar2026() {
//   const [data, setData] = useState([]);
//   const [loadingshow, setloadingshow] = useState(true);
//   const [show, setShow] = useState(false);
//   const [FetchDatavdo, setFetchDatavdo] = useState([]);
//   const { BaseURL } = useContext(URLstateContext);

//   useEffect(() => {
//     // Fetch Market Outlook data when component mounts
//     fetchMarketOutlookData();
//   }, []);

//   const clickyoutube = (event) => {
//     setShow(true);
//     fetchVideoLink(event);
//   };

//   const fetchMarketOutlookData = () => {
//     // Fetch Market Outlook data from the API
//     GetPostMethodData(BaseURL + "GetCommunicationHub", {
//       IICategoryID: 3, // Assuming 2 is the ID for Market Outlook
//       // IISubCategoryID: 0,
//     }).then((responseData) => {
//       if (responseData.data != null && responseData.data.length > 0) {
//         setData(DecryptAESdata(responseData.data));
//         setloadingshow(false);
//       } else {
//         setData([]);
//         setloadingshow(false);
//       }
//     });
//   };

//   const fetchVideoLink = (event) => {
//     GetPostMethodData(BaseURL + "GetVideoLink", {
//       IVsrno: event,
//     }).then((data) => {
//       if (data.data != null && data.data.length > 0) {
//         setFetchDatavdo(DecryptAESdata(data.data));
//       }
//     });
//   };

//   const handleClosePopup = () => {
//     setShow(false);
//   };

//   return (
//     <>
//       <section className="market-outlook-section">
//         <Container>
//           <Row>
//             <Col sm={12} style={{padding : 0}}>
//               <div className="market-outlook-container">
//                 {data === null && loadingshow === false ? (
//                   <h5 className="errormsgComNew">No Data Available !!!</h5>
//                 ) : (
//                   data &&
//                   data.map(({ Title, ThumbnailImage, CommunicationID }) => (
//                     <div
//                       className="market-outlook-item zoom"
//                       key={CommunicationID}
//                     >
//                       <h3>{Title}</h3>
//                       <span onClick={() => clickyoutube(CommunicationID)}>
//                         <img
//                           src={ThumbnailImage}
//                           className="img-fluid"
//                           alt="Thumbnail"
//                         />
//                       </span>
//                     </div>
//                   ))
//                 )}
//                 {loadingshow && (
//                   <div className="textcentervertex">
//                     <img src={animation} alt="Loading" />
//                     <div className="model_popup">Please Wait...</div>
//                   </div>
//                 )}
//               </div>
//             </Col>
//           </Row>
//         </Container>
//       </section>
//       {FetchDatavdo.map(({ Title, LinkLocation }, index) => (
//         <Modal show={show} className="modal modal-teams" key={index}>
//           <Modal.Body id="modal_info">
//             <div className="btnDiv">
//               <div className="" onClick={handleClosePopup}>
//                 <AiFillCloseCircle className="btncl" />
//               </div>
//             </div>
//             <div className="youtubepopup">
//               <p>{Title}</p>
//               <div>
//                 <iframe
//                   className="iframe-vdo"
//                   src={LinkLocation}
//                   title="YouTube video player"
//                   frameBorder="0"
//                   allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
//                   allowFullScreen
//                 ></iframe>
//               </div>
//             </div>
//           </Modal.Body>
//         </Modal>
//       ))}
//     </>
//   );
// }

// export default Calendar2026;


import React, { useEffect, useState } from "react";
import { Container, Row, Col, Modal } from "react-bootstrap";
import { AiFillCloseCircle } from "react-icons/ai";
import { FaFilePdf, FaYoutube } from "react-icons/fa";
import animation from "../../../../images/jm-animation.gif";
// import "../../../CommunicationHub/MarketOutlook.css"
import "./Calendar.css"
import CalendarImg1 from "../../../../images/JM Trade Chronicles 2026 doc-100.jpg"
import TradeChronics from "../../../../PDF/(JM) India Trade Calendar Information.pdf"
import { color } from "@amcharts/amcharts5";
import FinQBanner from "../../FinQBanner/FinQBanner";
import PdfIcon from "../../../../images/newIcon/PDF icon 1.svg"
import YoutubeIcon from "../../../../images/newIcon/Youtube-2.svg"


function Calendar2026() {

  const [show, setShow] = useState(false);
  const [videoLink, setVideoLink] = useState("");
  const [videoTitle, setVideoTitle] = useState("");
  // const [pathname, setPathName] = useState("");

  //   useEffect(() => {
  //     var pathname = window.location.pathname;
  //     const regEx = new RegExp("-", "g");
  //     const resultName = pathname.replace(regEx, " ");
  //     setPathName(resultName);
  //   });
  


  const data = [
    {
      CommunicationID: 1,
      Title: "India's Trade Chronicles",
      ThumbnailImage: CalendarImg1,
      PdfLink: TradeChronics,
      YoutubeLink: "https://www.youtube.com/embed/8e8gI5duHNk?si=Bt7qjhaOQvrFtXCn",
    },
  ];

  const handleYoutubeClick = (link, title) => {
    setVideoLink(link);
    setVideoTitle(title);
    // setShow(true);
  };

  const handleClosePopup = () => setShow(false);

  return (
    <>
      {/* <FinQBanner /> */}
{/* 
      <Container>
                <Row>
                  <Col>
                    <ul className="navigator-arrow">
                      <li>
                        <a href="/">
                          <i className="fa fa-home" aria-hidden="true"></i>
                        </a>{" "}
                        <i className="fa fa-angle-right" aria-hidden="true"></i>
                      </li>
                      <li>
                        <a href="/Insights">
                          <i>Insights</i>
                        </a>{" "}
                        <i className="fa fa-angle-right" aria-hidden="true"></i>
                      </li>
                      {/* <li>Calculator</li><i className="fa fa-angle-right" aria-hidden="true"></i> 
                    
                      {window.location.pathname !== "/Insights" ? (
                        <li>{pathname.split("/")[2]}</li>
                      ) : (
                        ""
                      )}
                    </ul>
                  </Col>
                </Row>
              </Container> */}
              
      <section className="market-outlook-section">

        <Container>
          <Row>
            <Col sm={12} style={{ padding: 0 }}>
              <div className="market-outlook-container">
                {data?.map(({ Title, ThumbnailImage, PdfLink, YoutubeLink, CommunicationID }) => (
                  <div className="market-outlook-item zoom" key={CommunicationID}>
                    <h3>{Title}</h3>

                    {/* Thumbnail */}
                    {/* <span onClick={() => handleYoutubeClick(YoutubeLink, Title)}> */}
                    <span>
                      <img src={ThumbnailImage} className="img-fluid" alt="Thumbnail" />

                    </span>
                    <p style={{fontSize: "0.9rem"}}>
                      We are celebrating India’s entrepreneurial spirit, its cultural richness, and its unwavering march toward global leadership. 
                      This serves as a daily reminder of who we are, where we come from, and the limitless possibilities that lie ahead. 
                      Let it inspire pride in our heritage, purpose in our present, and faith in India’s destined future.
                    </p>
                    

                    {/* Icons section below */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "20px",
                        marginTop: "10px",
                      }}
                    >
                      <a
                        href={PdfLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pdf-icon"
                        style={{
                          color: "#d32f2f",
                          transition: "transform 0.3s ease, opacity 0.3s ease",
                        }}
                         aria-label={`Download PDF: ${Title}`}
                      >
                        <img
                      src={PdfIcon}
                      alt="PDF"
                      width={28}
                      height={28}
                      style={{
                        cursor: "pointer",
                        transition: "transform 0.3s ease, opacity 0.3s ease",
                      }}
                    />
                      
                      </a>
                      <a href={YoutubeLink} style={{ cursor: "pointer" }} target="_blank"  aria-label={`Download PDF: ${Title}`}>
                       <img
                          src={YoutubeIcon}
                          alt="YouTube"
                          width={28}
                          height={28}
                          style={{
                            cursor: "pointer",
                            transition: "transform 0.3s ease, opacity 0.3s ease",
                          }}
                        />
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* YouTube modal */}
      {/* <Modal show={show} className="modal modal-teams" onHide={handleClosePopup}>
        <Modal.Body id="modal_info">
          <div className="btnDiv">
            <div onClick={handleClosePopup}>
              <AiFillCloseCircle className="btncl" />
            </div>
          </div>
          <div className="youtubepopup">
            <p>{videoTitle}</p>
            <div>
              <iframe
                className="iframe-vdo"
                src={videoLink}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </Modal.Body>
      </Modal> */}
    </>
  );
}

export default Calendar2026;
